import {
    PullQuoteColorOptions,
    PullQuoteInputs,
    PullQuoteStyleOptions,
} from './PullQuote';

export const pullQuoteTransformer = (node: any): PullQuoteInputs => {
    const style: PullQuoteStyleOptions = node.field_pull_quote_style;
    const color: PullQuoteColorOptions = node.field_pull_quote_bg_color;

    return {
        style,
        color,
        author: node.field_quote_author,
        text: node.field_quote_text?.value,
        image: node.relationships.field_single_image?.localFile,
        imageAlt: node.field_single_image?.alt,
    };
};
